import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Lock = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="lock icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 14C10 6.43712 16.4005 0 23.9694 0C31.5323 0 38 6.43105 38 14V22H39C40.6523 22 42 23.3477 42 25V45C42 46.6523 40.6523 48 39 48H9C7.3477 48 6 46.6523 6 45V25C6 23.3477 7.34772 22 9 22H10V14ZM36 14V22H31V14C31 10.1628 27.7948 7 23.9694 7C20.1308 7 17 10.176 17 14V22H12V14C12 7.5356 17.5111 2 23.9694 2C30.4338 2 36 7.54167 36 14ZM29 14V22H19V14C19 11.2671 21.2489 9 23.9694 9C26.7032 9 29 11.2803 29 14ZM9 24H10H11H18H19H29H30H37H38H39C39.5477 24 40 24.4523 40 25V45C40 45.5477 39.5477 46 39 46H9C8.4523 46 8 45.5477 8 45V25C8 24.4523 8.45228 24 9 24ZM24 27C20.9624 27 18.5 29.4624 18.5 32.5C18.5 34.4321 19.4963 36.13 21 37.1103V40C21 41.6569 22.3431 43 24 43C25.6569 43 27 41.6569 27 40V37.1103C28.5037 36.13 29.5 34.4321 29.5 32.5C29.5 29.4624 27.0376 27 24 27ZM20.5 32.5C20.5 30.567 22.067 29 24 29C25.933 29 27.5 30.567 27.5 32.5C27.5 33.8728 26.7098 35.0628 25.555 35.6367L25 35.9125V36.5322V40C25 40.5523 24.5523 41 24 41C23.4477 41 23 40.5523 23 40V36.5322V35.9125L22.445 35.6367C21.2902 35.0628 20.5 33.8728 20.5 32.5Z"
    />
  </svg>
)
